// extracted by mini-css-extract-plugin
export default {"kvmTip":"app-edge-devices-components-EdgeDevicesDatatable-EdgeDevicesDatatable-module__kvm-tip"};